import {useSuiContext} from '@s-ui/react-context'

const SortManagementInfoContent = () => {
  const {i18n} = useSuiContext()

  return (
    <div className="mt-SearchSortManagementInfo-content">
      <p className="mt-SearchSortManagementInfo-contentText">
        {i18n.t('NOTIFICATIONS.SORT_MANAGEMENT_NOTIFICATION.CONTENT')}
      </p>
    </div>
  )
}

SortManagementInfoContent.displayName = 'SortManagementInfoContent'

export default SortManagementInfoContent
